/*global $*/
/*eslint no-undef: "error"*/
export default class FilterOpen {
    classItem = 'filter-open--item'
    classButton = 'filter-open--button'
    classOpen = 'section---open'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            $(this).closest(`.${self.classItem}`).toggleClass(self.classOpen)
        })
    }
}
